if (!customElements.get('coin-product-payments')) {
  customElements.define('coin-product-payments', class extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => this.fit());
      this.resizeObserver.observe(this);
      this.onResize = () => this.fit();
      window.addEventListener('resize', this.onResize);
      this.fit();
    }
    fit() {
      const style = getComputedStyle(this);
      const width = parseFloat(style.getPropertyValue('--product-payment-width'));
      const gap = parseFloat(style.columnGap) || 0;
      if (!width) return;
      const count = Math.max(0, Math.floor((this.clientWidth + gap) / (width + gap)));
      [...this.children].forEach((icon, index) => { icon.hidden = index >= count; });
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.onResize);
    }
  });
}
